//import axios from 'axios';
//import authHeader from './auth-header';
import api from "./api";//Added 2024-04-18 for refreshToken

class RatingDataService {

  /*get(id) {
    return axios.get(process.env.VUE_APP_ROOT_API + `rating/${id}`, { headers: authHeader() });
  }*/

  /*create(data) { //OBSOLETE SINCE 2023-03-14 WHEN THIS IS DONE IN UPDATE
    return axios.post(process.env.VUE_APP_ROOT_API + `rating`, data, { headers: authHeader() });
  }*/

  //Used for PingTune
  create(data) {
    //return axios.post(process.env.VUE_APP_ROOT_API + `rating`, data, { headers: authHeader() }); //Replaced 2024-04-18 due to RefreshToken
    return api.post(`rating`, data);
  }

  update(id, data) {
    //return axios.put(process.env.VUE_APP_ROOT_API + `rating/${id}`, data, { headers: authHeader() }); //Replaced 2024-04-18 due to RefreshToken
    return api.put(`rating/${id}`, data);
  }

  delete(id) {
    //return axios.delete(process.env.VUE_APP_ROOT_API + `rating/${id}`, { headers: authHeader() }); //Replaced 2024-04-18 due to RefreshToken
    return api.delete(`rating/${id}`);
  }
}

export default new RatingDataService();